import * as React from "react";
import { useTranslation } from "react-i18next";
import { defaultCompare } from "logic/DefaultCompare";
import { Row, Alert } from "components/bootstrap";
import IfDashboard from "views/components/dashboard/IfDashboard";
import IfSearch from "views/components/search/IfSearch";
import Select from "components/common/Select";
const sortOptions = (options) => options.sort((option1, option2) => defaultCompare(option1.label, option2.label));
const WidgetSelection = ({ selectWidget, widgets, view }) => {
  const { t } = useTranslation("widgets");
  const widgetOption = (widget) => ({ label: view.getWidgetTitleByWidget(widget), value: widget });
  const widgetOptions = sortOptions(widgets.map((widget) => widgetOption(widget)).toArray());
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(IfSearch, null, t("export.search_contains_all"), /* @__PURE__ */ React.createElement("br", null), t("export.search_select_table")), /* @__PURE__ */ React.createElement(IfDashboard, null, t("export.dashboard_select_table"), /* @__PURE__ */ React.createElement("br", null), t("export.dashboard_equals_action"))), widgets.size !== 0 ? /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement("label", { htmlFor: "widget-selection" }, t("export.select_message_table")), /* @__PURE__ */ React.createElement(
    Select,
    {
      placeholder: t("export.select_message_table"),
      onChange: selectWidget,
      options: widgetOptions,
      inputId: "widget-selection"
    }
  )) : /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Alert, { bsStyle: "warning" }, t("export.no_message_table"))));
};
export default WidgetSelection;
